export function parseWindowLocationHash(isLive) {
	const hash = window.location.hash;
	let toReturn = {}
	if (isLive) {
		const matchUniqueId = hash && hash.replace("#","");
		try {
			if (matchUniqueId) {
				const parts = matchUniqueId.split('_');
				if (parts) {
					if (parts.length === 1) {
						toReturn = {
								isSport:true,
								sportId: parseInt(parts[0], 10)
						}
					}
					if (parts.length === 4) {
						toReturn = {
							isMatch:true,
							matchUniqueId: matchUniqueId,
							sportId: parseInt(parts[0], 10),
							countryId: parseInt(parts[1], 10),
							tournamentId: parseInt(parts[2], 10),
							matchId: parseInt(parts[3], 10)
						}
					}
				}
			}
		}catch(err) {
			console.log(err);
			return null;
		}
    	return toReturn;
	}else{
		return null;
	}
}
